import { Dialog } from 'vant'
import { _Aso_Minus, _Aso_Divide } from 'model/_SealBigNumber'
import { dealServiceJumpOrder, dealServiceSaveDraft } from './utils'
import { post } from '../../utils/request'
import { notNeedSaveDraft } from './enum'

const canAddMoneyList = [
  '/wap/campaign',
]

const dealTeamPriceValid = async (total, needSave, serviceType, option) => {
  const res = await post('MyOrder/checkTeamQuota', {
    price: total
  })
  console.log(res)
  const { teamId, status } = (res && res.data) || {}
  if (teamId) {
    const noSave = notNeedSaveDraft.includes(serviceType) || !needSave
    if (status === 'error') {
      const type = res && res.data.type
      if (type === 'teamQuota') {
        const lang = noSave ? 
          'Your available team account balance is insufficient this month, contact the team administrator to adjust.' : 
          'Your available team account balance is insufficient this month, click OK to save the order as a draft, and contact the team administrator to adjust.'
        await Dialog.confirm({
          closeOnClickOverlay: true,
          message: lang,
          title: '',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
        }).then(async() => {
          if (!noSave) {
            await dealServiceSaveDraft(serviceType, false, option)
            dealServiceJumpOrder(serviceType)
          }
        })
          .catch(() => {
            return false
          })
      } else if (type === 'leaderBalance') {
        const need = _Aso_Divide(res.data.need || 0, 100, 2)
        const lang = noSave ? 
          ' required to start this order. Contact your team admin for recharge.' : 
          ' required to start this order. Please click OK to save the order as a draft, then contact your team admin for recharge.'
        await Dialog.confirm({
          closeOnClickOverlay: true,
          message: `Insufficient balance. Additional $${need}${lang}`,
          title: '',
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
        }).then(async() => {
          if (!noSave) {
            await dealServiceSaveDraft(serviceType, false, option)
            dealServiceJumpOrder(serviceType)
          }
        })
          .catch(() => {
            return false
          })
      }
      return false
    }
  }
  return true
}

/**
 * @description 处理价格校验
 * @param {Vuex Instance} ctx
 * @param {是否是团队成员} isTeam
 * @param { total, balance, serviceType, team, account, refreshBalance, setNeedMoney, setInAddMoney, saveDraftbeforePro } option
 * @returns
 */
const dealResponsePriceValid = async(isTeam = false, option = {}) => {
  const { total } = option.params
  const { serviceType, team, account } = option.params
  const { refreshBalance, setNeedMoney, setInAddMoney, saveDraftbeforePro, setNeedJumpOrder, getBalance } = option.func
  refreshBalance && await refreshBalance()
  const balance = getBalance()
  if (isTeam && team) {
    return await dealTeamPriceValid(total, true, serviceType, option)
  } else if (balance < total && account) {
    const need = _Aso_Divide(_Aso_Minus(total, balance, 2), 100, 2)
    // ctx.commit('setNeedMoney', need)
    setNeedMoney && setNeedMoney(need)
    Dialog.confirm({
      closeOnClickOverlay: true,
      message: `The account balance is insufficient, still need $${need} to start this order.\nThe order will be saved as a draft in My Orders when you go to Add Money, you can check it after finish payment.`,
      title: '',
      confirmButtonText: 'Add money',
      cancelButtonText: 'Cancel',
    }).then(() => {
      if(serviceType === 'ASO_SERVICE'||serviceType === 'API_SERVICES'){
        setInAddMoney && setInAddMoney()
        return 
      }
      if(canAddMoneyList.includes(window.location.pathname)) {
        setNeedJumpOrder && setNeedJumpOrder()
      }
      saveDraftbeforePro && saveDraftbeforePro()
      setInAddMoney && setInAddMoney()
    }).catch(() => {
    })
    return false
  }
  return true
}

export {
  dealTeamPriceValid,
  dealResponsePriceValid
}
